import { Component } from '@angular/core';

@Component({
  selector: 'app-correction-dialog',
  templateUrl: './correction-dialog.component.html',
  styleUrls: ['./correction-dialog.component.css']
})
export class CorrectionDialogComponent {

  constructor(
  ) {}

}
